import { defineMessages } from "react-intl";

export const messages = defineMessages({
  emptyText: {
    id: "TJ5+Fb",
    defaultMessage: "No subscriptions found",
  },
  subscriptions: {
    defaultMessage: "Subscriptions",
    id: "J+dIsA",
  },
});

export const columnsMessages = defineMessages({
  order: {
    id: "ydKLFv",
    defaultMessage: "Original Order",
  },
  customer: {
    id: "hkENym",
    defaultMessage: "Customer",
  },
  status: {
    id: "tzMNF3",
    defaultMessage: "Status",
  },
  nextPayment: {
    id: "8X6Kwp",
    defaultMessage: "Next payment",
  },
  interval: {
    id: "6m3w+3",
    defaultMessage: "Interval",
  },
  amount: {
    id: "/0TOL5",
    defaultMessage: "Amount",
  },
  originalOrderDate: {
    id: "IMFcpn",
    defaultMessage: "Original order date",
  },
});
